<!-- results-table.component.html -->
<h1 mat-dialog-title>
    <strong>{{ action | translate }}</strong> tipo de documento
    <span *ngIf="action == 'Delete'"> {{ LOCAL_DATA.nombre }}</span>
</h1>
<div mat-dialog-content fxLayout="column">
    <div fxFlex *ngIf="action != 'Delete'">
        <mat-form-field fxFlex>
            <mat-label>Sujeto</mat-label>
            <mat-select
                [(ngModel)]="LOCAL_DATA.tipo"
                [required]="true"
                class="roleSelect"
                [disabled]="action == 'View'"
                [compareWith]="compareObjects"
            >
                <mat-option
                    *ngFor="let tipo of tipos_documento"
                    [value]="tipo.value"
                >
                    {{ tipo.nombre }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div fxFlex>
        <mat-form-field fxFlex *ngIf="action != 'Delete'">
            <mat-label>Nombre</mat-label>
            <textarea
                [disabled]="action == 'View'"
                matInput
                [(ngModel)]="LOCAL_DATA.nombre"
                [required]="true"
                cdkTextareaAutosize
                #nombreInput
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
                autofocus
            ></textarea>
        </mat-form-field>
    </div>

    <mat-form-field *ngIf="action != 'Delete'" class="select-list">
        <mat-label>País</mat-label>
        <mat-select
            [(ngModel)]="LOCAL_DATA.pais"
            class="roleSelect"
            [required]="true"
            [disabled]="action == 'View'"
            [compareWith]="compareObjects"
        >
            <mat-option *ngFor="let pais of paises" [value]="pais">
                {{ pais.nombre }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!--
  <div fxFlex *ngIf="action != 'Delete'">
    <mat-form-field  fxFlex>
      <mat-label>País</mat-label>
      <input
          placeholder="País"
          #tipoInput
          [formControl]="tipoCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
          [disabled]="action == 'View'">
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let tipo of filteredPaises | async" [value]="tipo">
          {{tipo.nombre}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  -->
</div>
<div mat-dialog-actions>
    <button
        mat-button
        (click)="doAction()"
        *ngIf="action != 'View'"
        [disabled]="
            LOCAL_DATA.pais == null ||
            LOCAL_DATA.nombre == '' ||
            LOCAL_DATA.nombre.length <= 1 ||
            LOCAL_DATA.tipo == null
        "
    >
        {{ action | translate }}
    </button>
    <button mat-button (click)="closeDialog()" mat-flat-button color="warn">
        {{ "Cancel" | translate }}
    </button>
</div>
